import apiClient from './api';
import { ApiResponse, TaskVersion, TaskVersionPayload } from '../types';

export const taskVersionApi = {
  // 获取所有任务类型版本
  getTaskVersions: (): Promise<ApiResponse<TaskVersion[]>> =>
    apiClient.get('/admin/task-versions'),

  // 获取指定任务类型版本
  getTaskVersion: (taskType: number): Promise<ApiResponse<TaskVersion>> =>
    apiClient.get(`/admin/task-versions/${taskType}`),

  // 创建或更新任务类型版本
  saveTaskVersion: (payload: TaskVersionPayload): Promise<ApiResponse<TaskVersion>> =>
    apiClient.post('/admin/task-versions', payload),

  // 启用/禁用任务类型版本
  // 根据文档 5.3.3，enabled 参数应该通过查询参数传递
  setTaskVersionEnabled: (
    taskType: number,
    enabled: boolean
  ): Promise<ApiResponse<string>> =>
    apiClient.post(`/admin/task-versions/${taskType}/enable`, null, { 
      params: { enabled } 
    }),
};


